<div>

  <div [formGroup]="filtri">

    <!-- filtri iscritti -->
    <div class="flex flex-column align-items-center sm:flex-row mb-5 pt-5">

      <!-- filtri -->
      <div class="flex align-items-center justify-content-center mb-5 sm:mb-0">

        <!-- ricerca iscritti o altri elementi -->
        <div class="mr-3">
          <span class="p-input-icon-left p-input-icon-right p-float-label">
            <i class="pi pi-search"></i>
            <input type="text" id="cercaIscritto" class="p-inputtext-lg shadow-4" pInputText formControlName="inserimento" />
            <label for="cercaIscritto">Cerca Iscritto</label>
            <i class="pi pi-times pr-1" id="clearIcon" (click)="resetBoxRicerca()"></i>
          </span>
        </div>

      </div>

      <div class="flex">
        <div class="mr-3 bottoniStyle">
          <p-button
            (click)="mandaInStampa()"
            icon="pi pi-print"
            iconPos="right"
            severity="warning"
            [disabled]="!deliberaCorrente?.stampa || !role_service.isIscrizioniRole()"
            pTooltip="Stampa Riepilogo Chiuso"
            tooltipPosition="bottom" />
        </div>
        <div class="mr-3 bottoniStyle">
          <p-button
            type="button"
            icon="pi pi-table"
            iconPos="right"
            (click)="printIscrittiXLS()"
            pTooltip="Genera XLS"
            tooltipPosition="bottom"
            [disabled]="!role_service.isAlboOrConsultazione()" />
        </div>
        <p-confirmDialog />
        <div class="mr-3 bottoniStyle">
          <p-button
            type="button"
            (click)="confermaInvio($event)"
            icon="pi pi-envelope"
            iconPos="right"
            pTooltip="Invia Mail agli Iscritti"
            tooltipPosition="bottom"
            [disabled]="role_service.isConsultazioneRole()" />
        </div>
        <div class="flex bottoniStyle">
          @if(xlsSpinner){
            <div class="pr-4 pt-2">
              <i class="pi pi-spin pi-cog" style="font-size: 2rem"></i>
            </div>
          }
          @else{
            <p-button
              type="button"
              icon="pi pi-download"
              iconPos="right"
              class="mr-3"
              (click)="generaCsv()"
              pTooltip="Genera CSV"
              tooltipPosition="bottom"
              [disabled]="!role_service.isAlboOrConsultazione()"></p-button>
          }
        </div>
      </div>

      <div class="flex align-items-center xl:mb-0 bottoniStyle">

        <p-button
          class="clearFiltri"
          size="small"
          [outlined]="true"
          icon="pi pi-filter-slash"
          (click)="clearFilters()"
          pTooltip="Pulisci Filtri"
          tooltipPosition="bottom" />

      </div>

    </div>

  </div>

  <div class="mb-5">

    <!-- PAGINATOR della tabella -->
    <div class="flex justify-content-start">
      <p-paginator
        [rows]="pageSize"
        [first]="currentPage"
        [rowsPerPageOptions]="[25, 100, 250, 500]"
        (onPageChange)="pageChange($event)"
        [totalRecords]="totaleDati"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} di {totalRecords}"
        [showPageLinks]="false"
      >
      </p-paginator>
    </div>

  </div>

  <!-- tabella -->
  <div>
    <p-table
      #dt
      [value]="listaIscritti"
      [rowHover]="true"
      (onLazyLoad)="ordinamento($event)"
      [customSort]="true"
      [lazy]="true"
      [sortField]="orderColumnName"
      [sortOrder]="orderCustom(order)"
    >
      <!-- headers -->
      <ng-template pTemplate="header">
          <tr>

            @for(headerName of headersTabella; track $index){
              <th [pSortableColumn]="rowsTabella[$index]">
                {{ headerName }}
                <p-sortIcon [field]="rowsTabella[$index]"></p-sortIcon>
              </th>
            }

          </tr>
      </ng-template>

      <!-- rows -->
      <ng-template pTemplate="body" let-iscritto>

        <tr [routerLink]="generaRoutingLink(iscritto)">

            @for(rowName of rowsTabella; track $index){
              @if(rowName == 'domandaData'){
                <td>{{ iscritto[rowName] | date: 'dd/MM/yyyy' }}</td>
              }
              @else{
                <td>{{ iscritto[rowName] }}</td>
              }
            }

        </tr>

      </ng-template>

      <ng-template pTemplate="caption">
            Totale iscritti in delibera {{totaleIscritti}}
    </ng-template>

    </p-table>

  </div>

  <p-toast position="bottom-center"></p-toast>

</div>
